module.exports = __webpack_public_path__ + "voicecall_38x38.98ee4e6eac4e482dc8b2db9eadafb031.png";